module.exports = {
  message: {
    system: '系统管理',
    operationLog: '操作日志',
    loginLog: '登录日志',
    dashboardManagement: '仪表盘管理',
    productList: '产品管理',
    dashboardList: '仪表盘管理',
    changeCompany: '切换单位',
    groupList: '分组管理',
    lang: {
      zh: '中文',
      en: '英文',
    },
  },
};
